export default "__VITE_PUBLIC_ASSET__63372456__"